import React from 'react';
import { businessInfo } from '../mockData';

export const HeroSection = () => {
  const scrollToForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative pt-40 pb-28 min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-white to-[#FAFBFC]">
      {/* Animated Gradient Blob */}
      <div className="absolute top-[-20%] right-[-15%] w-[900px] h-[900px] bg-gradient-radial from-[#7CB342]/[0.06] to-transparent rounded-full pointer-events-none animate-float" />
      
      <div className="max-w-[1600px] mx-auto px-4 sm:px-10 md:px-20 w-full relative z-10">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 sm:gap-24 lg:gap-32 items-center">
          {/* Left Content */}
          <div className="max-w-[720px]">
            {/* Badge */}
            <div className="inline-flex items-center gap-[10px] px-[22px] py-[10px] bg-gradient-to-br from-[#006B3F]/[0.05] to-[#7CB342]/[0.05] border border-[#006B3F]/[0.12] rounded-full font-semibold text-[13px] tracking-[0.03em] text-[#006B3F] mb-10 transition-all duration-300 hover:bg-gradient-to-br hover:from-[#006B3F]/[0.08] hover:to-[#7CB342]/[0.08] hover:border-[#006B3F]/[0.2]">
              <span className="w-[7px] h-[7px] bg-[#7CB342] rounded-full animate-pulse" />
              Velbert-Langenberg • Kreis Mettmann
            </div>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl md:text-[68px] lg:text-[78px] font-[900] leading-[1.05] tracking-[-0.04em] mb-8 text-[#0D0D0D]">
              Fahrzeugzulassung<br/>
              <span className="bg-gradient-to-r from-[#006B3F] to-[#7CB342] bg-clip-text text-transparent">
                ohne Wartezeit
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-base sm:text-lg md:text-[21px] leading-[1.75] text-[#5A5A5A] mb-[52px] font-normal max-w-[580px]">
              Professionelle Zulassungsdienstleistungen für Ihren neuen oder gebrauchten PKW. 
              Wir übernehmen alle Behördengänge – schnell, zuverlässig und vollständig digital.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-[18px] mb-[72px]">
              <button
                onClick={scrollToForm}
                className="px-6 sm:px-11 py-[22px] bg-gradient-to-br from-[#006B3F] to-[#00854D] hover:from-[#005230] hover:to-[#006B3F] text-white rounded-xl font-bold text-base sm:text-[17px] tracking-tight transition-all duration-[400ms] hover:translate-y-[-4px] shadow-[0_8px_24px_rgba(0,107,63,0.2)] hover:shadow-[0_16px_40px_rgba(0,107,63,0.35)] w-full sm:w-auto"
              >
                Anfrage starten
              </button>
              <button
                onClick={scrollToForm}
                className="px-6 sm:px-11 py-[22px] bg-transparent hover:bg-[#006B3F]/[0.02] text-[#2A2A2A] hover:text-[#006B3F] border-2 border-[#E8E8E8] hover:border-[#006B3F] rounded-xl font-bold text-base sm:text-[17px] tracking-tight transition-all duration-300 w-full sm:w-auto"
              >
                Mehr erfahren
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 sm:gap-16 pt-14 border-t border-[#006B3F]/[0.12]">
              <div className="flex flex-col gap-[10px]">
                <div className="text-3xl sm:text-[48px] font-[900] tracking-[-0.03em] text-[#0D0D0D]">
                  <span className="bg-gradient-to-r from-[#006B3F] to-[#7CB342] bg-clip-text text-transparent">20</span> Min
                </div>
                <div className="text-[14px] text-[#5A5A5A] font-medium tracking-tight">
                  Durchschnittliche Bearbeitungszeit
                </div>
              </div>
              <div className="flex flex-col gap-[10px]">
                <div className="text-[48px] font-[900] tracking-[-0.03em] text-[#0D0D0D]">
                  150+
                </div>
                <div className="text-[14px] text-[#5A5A5A] font-medium tracking-tight">
                  Zufriedene Kunden in 2024
                </div>
              </div>
              <div className="flex flex-col gap-[10px]">
                <div className="text-[48px] font-[900] tracking-[-0.03em] text-[#0D0D0D]">
                  100%
                </div>
                <div className="text-[14px] text-[#5A5A5A] font-medium tracking-tight">
                  Digital & Transparent
                </div>
              </div>
            </div>
          </div>

          {/* Right - Image with Floating Card */}
          <div className="relative h-[680px]">
            <div className="absolute w-full h-full rounded-[28px] overflow-hidden shadow-[0_32px_80px_rgba(0,0,0,0.14)] transition-transform duration-600 hover:scale-[1.02]">
              <img 
                src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=900&h=700&fit=crop&q=80" 
                alt="Premium Fahrzeugzulassung"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Floating Price Card */}
            <div className="absolute bottom-12 left-[-80px] bg-gradient-to-br from-white to-[#F8F9FA] p-10 rounded-[20px] shadow-[0_28px_70px_rgba(0,0,0,0.18)] z-20 min-w-[340px] border border-[#006B3F]/[0.08] transition-all duration-[400ms] hover:translate-y-[-8px] hover:shadow-[0_36px_90px_rgba(0,0,0,0.22)]">
              <div className="inline-block px-[14px] py-[6px] bg-[#E53935]/[0.08] text-[#E53935] rounded-lg text-[11px] font-bold tracking-[0.05em] uppercase mb-4">
                Festpreis
              </div>
              <div className="text-[16px] text-[#5A5A5A] mb-[14px] font-medium tracking-tight">
                Schnellzulassung ab
              </div>
              <div className="text-[52px] font-[900] text-[#0D0D0D] tracking-[-0.03em] mb-2">
                149,90€
              </div>
              <div className="text-[15px] text-[#5A5A5A] font-medium">
                Alles inklusive – keine versteckten Kosten
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          50% {
            transform: translate(30px, -30px) scale(1.05);
          }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};
